// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"explore-templates-list-new_skeleton__M0SMo","skeletonContainer":"explore-templates-list-new_skeletonContainer__2vlCy"};